"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.COUNTRIES_CONFIG = void 0;
var Flags = __importStar(require("../CountryDropdown/Flags"));
exports.COUNTRIES_CONFIG = [
    {
        flag: Flags.FlagFR,
        flagCode: 'FR',
        href: 'https://www.veepee.fr/authentication/logout/?geositeId=1',
        label: 'France'
    },
    {
        flag: Flags.FlagDE,
        flagCode: 'DE',
        href: 'https://www.veepee.de/authentication/logout/?geositeId=2',
        label: 'Deutschland'
    },
    {
        flag: Flags.FlagES,
        flagCode: 'ES',
        href: 'https://www.veepee.es/authentication/logout/?geositeId=3',
        label: 'España'
    },
    {
        flag: Flags.FlagIT,
        flagCode: 'IT',
        href: 'https://www.veepee.it/authentication/logout/?geositeId=4',
        label: 'Italia'
    },
    {
        flag: Flags.FlagAT,
        flagCode: 'AT',
        href: 'https://www.veepee.at/authentication/logout/?geositeId=7',
        label: 'Österreich'
    },
    {
        flag: Flags.FlagBE,
        flagCode: 'BE-FR',
        href: 'https://fr.veepee.be/authentication/logout/?geositeId=70',
        label: 'Belgique'
    },
    {
        flag: Flags.FlagBE,
        flagCode: 'BE-NL',
        href: 'https://nl.veepee.be/authentication/logout/?geositeId=71',
        label: 'België'
    },
    {
        flag: Flags.FlagLU,
        flagCode: 'LU',
        href: 'https://www.veepee.lu/authentication/logout/?geositeId=73',
        label: 'Luxembourg'
    },
    {
        flag: Flags.FlagNL,
        flagCode: 'NL',
        href: 'https://www.veepee.nl/authentication/logout/?geositeId=76',
        label: 'Nederland'
    },
    {
        flag: Flags.FlagCH,
        flagCode: 'CH-FR',
        href: 'https://www.veepee.ch/fr/login',
        label: 'Suisse'
    },
    {
        flag: Flags.FlagCH,
        flagCode: 'CH-DE',
        href: 'https://www.veepee.ch/de/login',
        label: 'Schweiz'
    }
];
